export function initializePanelExpand(root) {
	const handlePanelExpand = (event) => {
		const expandLink = event.target.closest?.('[data-toggle="panel-expand"]');
		if (!expandLink || !root.contains(expandLink)) return;

		event.preventDefault();
		expandLink.closest('.card')?.classList.toggle('panel-expand');
	};

	root.addEventListener('click', handlePanelExpand);

	return () => root.removeEventListener('click', handlePanelExpand);
}
